import { Toast } from "dlibs";


export const toast = new Toast();